import {
  ApigetPageconfig
} from '@api/service'
import deepAssign from 'deep-assign'
import urijs from 'urijs'
import jsonp from 'jsonp'

import {
  STEP,
  ERROR_TIPS,
  changeDomain,
  getValidDomain,
  getOneCdn,
  getTxtPath,
  getCdnsByEnv
} from '@c/changeLinedialog'
import {
  get as _get
} from 'lodash-es'
const {
  Decrypt
} = require('~/assets/tools/crypto')
const KEY_DOMAIN = require('~/assets/tools/key-domain')
//获取本地缓存的配置
const DEFAULT_APPCONFIG = {
  lottery_config: {
    configValue: {
      supportPlayway: 3, //1表示只支持官方2表示只支持信用3表示官方信用都支持
      defaultPlayway: 2, //1表示默认官方2表示默认信用
      xyPlaywayDefaultBetAmountMode: 0, //0快捷 1一般
      luziLimit: 50,//路子图默认条数
    }
  }
}
let APPCONFIG = {}
try {
  if (localStorage.NEWAPPCONFIG) {
    APPCONFIG = Object.assign({}, DEFAULT_APPCONFIG, JSON.parse(localStorage.NEWAPPCONFIG))
  }
} catch (e) {
  console.warn(e)
  APPCONFIG = DEFAULT_APPCONFIG
}

export default {
  namespaced: true,
  state: {
    pageScrollTop: 0,
    activeForumLotteryCode: '',
    myAppScroll: null,
    routeName: '',
    appConfig: APPCONFIG,
    defaultNoticeConfig:
    {
      "interval": 86400000, //弹窗间隔时间单位 ms （ 默认 86400000  一天间隔）
      "onInit": {  //页面打开时
        "isEnable": 1, // 1启用 0不启用  默认1
        "trigger": 0, //是否立即触发不判断间隔时间  0否 1是   默认 0
        "updateInterval": 1 //当触发时是否更新记录的弹窗时间  1更新 0不更新   默认1
      },
      "onLogin": {
        "isEnable": 0, // 1启用 0不启用  默认0
        "trigger": 1, //是否立即触发不判断间隔时间  0否 1是 默认 1
        "updateInterval": 1 //当触发时是否更新记录的弹窗时间  1更新 0不更新   默认1
      }
    },
    restrictRoute: [],
    mnagementRoute: [],
    showBottomTab: true,
    homeCurType: '',
    headerVisible: true,
    isInApp: false,
    appReady: false,
    domainList: [],
    changeLineState: {
      show: false,
      step: -1,
      errorText: '',
      mode: -1
    },
    domainLen: 0,
    showChangeLineloading: false,
    gameTabRoutes: [
      {
        title: "官方",
        key: "lottery",
      },
      {
        title: "信用",
        key: "credit",
      },
      {
        title: "彩票",
        key: "hotLottery",
      },
      {
        title: "真人",
        key: "realman",
      },
      {
        title: "电游",
        key: "elegame",
      },
      {
        title: "棋牌",
        key: "chess",
      },
      {
        title: "体育",
        key: "sports",
      },
      {
        title: "电竞",
        key: "elegameSports",
      },
      {
        title: "捕鱼",
        key: "fish",
      },
    ],
    cdnParameter: { //缩略图后缀
      'query': { //query
        minHeadImageParameter: '?imageView2/1/w/100/h/100/q/75', //当前100*100 具体看cdn配置 用于缩略时头像展示
        maxHeadImageParameter: '?imageView2/0/interlace/1/q/50|imageslim', //用于头像大图展示
        minImageVeiwParameter: '?imageMogr2/auto-orient/thumbnail/x240/interlace/1/blur/1x0/quality/75|imageslim', //最高240px 宽度等比缩放 用于图片消息缩略图展示
        maxImageVeiwParameter: '?imageView2/0/interlace/1/q/50|imageslim', //用于图片消息完整展示 大小不变提示挤压
      },
      'path': { //path
        minHeadImageParameter: '/ImageView/100x100,q75', //用于好友列表，消息列表中较小头像的展示，压缩尺寸与质量
        maxHeadImageParameter: '/ImageView/q50', //暂无压缩参数，但保留（压缩质量但尺寸不变，暂未用到 保留）
        minImageVeiwParameter: '/ImageView/x240,q75', //（压缩尺寸与质量  最高限制240px 宽度等比缩放，用于im图片消息显示的缩略图）
        maxImageVeiwParameter: '/ImageView/q50', //暂无压缩参数但保留 （压缩质量 尺寸不变， 用于im图片消息点开的大图展示）
      },

    },
    userToWgdCountSpeed: {},
  },
  mutations: {
    setPageScrollTop(state, val) {
      state.pageScrollTop = val
    },
    setActiveForumLotteryCode(state, code) {
      state.activeForumLotteryCode = code
    },
    setHeaderVisible(state, payload) {
      state.headerVisible = payload
    },
    setIsInApp(state, payload) {
      state.isInApp = payload
    },
    setmyAppScroll(state, payload) {
      state.myAppScroll = payload
    },
    setRouteName(state, payload) {
      state.routeName = payload
    },
    setRestrictRoute(state, payload) {
      state.restrictRoute = [...payload]
    },
    setManagementRoute(state, payload) {
      state.mnagementRoute = [...payload]
    },
    setAppConfig(state, payload) {
      state.appConfig = payload
      localStorage.NEWAPPCONFIG = JSON.stringify(payload)
    },
    setHomeCurType(state, payload) {
      state.homeCurType = payload
    },
    setAppReady(state, payload) {
      state.appReady = payload
    },
    setshowBottomTab(state, payload) {
      state.showBottomTab = payload
    },
    setDomain(state, payload) {
      state.domainList = payload
    },
    clearDomain(state, payload) {
      state.domainList = []
    },
    setChangeLineState(state, payload) {
      state.changeLineState = payload
    },
    setUserToWgdCountSpeed(state, param) {
      state.userToWgdCountSpeed[param.name] = param.content
    },

  },
  actions: {
    //获取应用配置
    getAppConfig({
      state,
      commit
    }) {
      return new Promise(async (resolve, reject) => {
        const currentUrl = window.location.href;
        // 获取 # 符号之前的部分（即 ? 前面的部分）
        const urlWithoutHash = currentUrl.split('#')[0];
        // 使用正则表达式匹配 configName 参数
        const configNameMatch = urlWithoutHash.match(/configName=([^&]+)/);
        const configName = configNameMatch ? configNameMatch[1] : '';

        let data = process.env.VUE_APP_CURRENTMODE == 'dev' ? {
          configName: configName
        } : { configName: configName }
        const RES = await ApigetPageconfig(data)

        if (RES.code == '12200') {
          let config = {}
          try {
            RES.data.forEach((c, index) => {
              c.configValue = JSON.parse(c.configValue)
              config[c.configKey] = c
            })
            config = Object.assign({}, DEFAULT_APPCONFIG, config)
            console.log(config)
            commit('setAppConfig', config)
          } catch (e) {
            commit('setAppConfig', DEFAULT_APPCONFIG)
            console.warn(e)
          }
        }
        resolve(RES)
      })
    },
    async selectDomainItem({
      state,
      commit
    }, payload) {
      commit(
        'setChangeLineState',
        Object.assign(state.changeLineState, {
          step: STEP.SUCCESS
        })
      )
      //changeDomain({ commit, state }, [payload]);
      // window.$domain = payload
      const domainCheckMode = _get(state, 'appConfig.app_config.configValue.check_domain_h5_config.mode', null)
      if (domainCheckMode === 1) {
        window.$domain = payload
      } else if (domainCheckMode === 2) {
        window.location.href = `${payload}/#${$app.$route.path}`
      }
    },
    async getDomain({
      state,
      commit
    }, payload) {
      // jsonp('https://pv.sohu.com/cityjson?ie=utf-8')
      const LxToast = document.querySelector('.lx-toast')
      if (LxToast) {
        LxToast.style.display = 'none'
      }

      const site_flag = _get($app.$store.state, 'sysParameter.sysParam.site_flag')
      const site_code = _get($app.$store.state, 'sysParameter.sysParam.site_code')
      commit(
        'setChangeLineState',
        Object.assign(state.changeLineState, {
          show: true,
          step: STEP.CHECKING,
          mode: payload
        })
      )
      const cdns = getCdnsByEnv(site_flag)
      const txtPath = getTxtPath(site_flag, site_code)
      let domain_AES = ''
      try {
        domain_AES = await Promise.any(getOneCdn(cdns, txtPath))
      } catch (error) {
        // jsonp('https://pv.sohu.com/cityjson?ie=utf-8')
        commit(
          'setChangeLineState',
          Object.assign(state.changeLineState, {
            show: true,
            step: STEP.ERROR,
            errorText: ERROR_TIPS.NO_CONFIG
          })
        )
        return false
      }

      const domainData = Decrypt(domain_AES, KEY_DOMAIN.key, KEY_DOMAIN.iv)
      let arr = JSON.parse(domainData).domains;
      let domains = []
      if (Array.isArray(arr)) {
        domains = arr.map((item) => {
          return item.domain
        })
      } else {
        domains = arr.split(',')
      }

      const domainArr = domains;

      if (payload == 0) {
        changeDomain({
          commit,
          state
        }, domainArr)
      }
      if (payload == 1) {
        commit('clearDomain')
        const domainInfoPromise = Promise.allSettled(getValidDomain(domainArr, true))
        domainInfoPromise.then(function (results) {
          const domainInfo = results.map(item => {
            return item.reason || item.value
          })
          commit(
            'setChangeLineState',
            Object.assign(state.changeLineState, {
              show: true,
              step: STEP.CHECKINGALL
            })
          )
          commit('setDomain', domainInfo)
        })
      }
    }
  },
  getters: {
    //现在点击的论坛彩种是奇数还是偶数1
    forumIndexIsodd(state, getters, rootState) {

      try {
        let results = {}
        if (rootState.sysParameter.forum_support_lottery && rootState.sysParameter.forum_support_lottery.length > 0) {
          results = rootState.sysParameter.forum_support_lottery.find((item, index) => {
            return item.lotteryCode === state.activeForumLotteryCode
          })

        }
        return results
      } catch {
        return {}

      }

    },
    cdn(state) {
      return process.env.VUE_APP_CDN
      // try {
      //     return state.appConfig.site_config.configValue.cdn
      // } catch {
      //     return ''
      // }
    },
    customUploadAvatorCdn(state) {
      // try {
      //     return state.appConfig.site_config.configValue.upload_cdn;
      // } catch {
      //     return "";
      // }
      // state.appConfig.site_config.configValue.upload_cdn = 'https://baidu.COM,https://baidu.com/////,https://www.lawhua.top,https://qny.chinalianxun.org'
      let cdn = ''
      try {
        cdn = state.appConfig.site_config.configValue.cdn
      } catch { }
      let pageConfigUploadCdn = {}
      let prsdPageConfigUploadCdn = {}
      try {
        // pageConfigUploadCdn = state.appConfig.site_config.configValue.upload_cdn
        pageConfigUploadCdn = {
          "qiniu": {
            "domains": "https://qny-img.365bj.top,https://qny-img.xiaodouyijia.xyz,https://qny-img.fqzy1.top,https://qny.kfsjblog.top",
            "paramType": "query"
          },
          "minio": {
            "domains": "https://zh-minio-tx.chenhoa.co,https://zh-minio-tx.chenhoa.co,https://minio-2.app4mac.fun",
            "paramType": "path"
          }
        }
        console.warn('upload_cdn域名:', pageConfigUploadCdn)
      } catch { }
      Object.keys(pageConfigUploadCdn).forEach(plat => {
        let data = {
          "domains": [],
          "paramType": pageConfigUploadCdn[plat].paramType
        }
        let list = pageConfigUploadCdn[plat].domains.split(',');
        list.forEach((domain) => {
          const pdomain = urijs(domain).normalize().toString()
          const hasDomain = data.domains.find(item => {
            const pitem = urijs(item).normalize().toString()
            return pitem == pdomain
          })
          if (!hasDomain) {
            data.domains.push(domain)
          }

        })
        prsdPageConfigUploadCdn[plat] = data;

      })
      return Object.keys(prsdPageConfigUploadCdn).length ? prsdPageConfigUploadCdn : {
        "qiniu": {
          "domains": [cdn],
          "paramType": "query"
        }
      }
      //   pageConfigUploadCdn.forEach(domain => {
      //     const pdomain = urijs(domain)
      //       .normalize()
      //       .toString()
      //     const hasDomain = prsdPageConfigUploadCdn.find(item => {
      //       const pitem = urijs(item)
      //         .normalize()
      //         .toString()
      //       return pitem == pdomain
      //     })
      //     if (!hasDomain) {
      //       prsdPageConfigUploadCdn.push(domain)
      //     }
      //   })
      //   return prsdPageConfigUploadCdn.length ? prsdPageConfigUploadCdn : [cdn]
    },
    project_name(state) {
      try {
        return state.appConfig.site_config.configValue.project_name
      } catch {
        return ''
      }
    },
    webname(state) {
      try {
        return state.appConfig.site_config.configValue.name
      } catch {
        return ''
      }
    },
    app_logo(state) {
      try {
        return state.appConfig.site_config.configValue.app_logo
      } catch {
        return ''
      }
    },
    app_my_config(state) {
      const app_my_config = {
        wallet: {
          name: '充值'
        },
        withdrawal: {
          name: '提现'
        },
        transfer: {
          name: '额度转换'
        },
        transfertomember: {
          name: '转账'
        },
        balanceIncome: {
          name: '余额生金'
        },
        bettingplatform: {
          name: '投注记录'
        },
        rechargeWithdrawalRecord: {
          name: '充提记录'
        },
        billChangeRecord: {
          name: '账变记录'
        },
        personalReport: {
          name: '个人报表'
        },
        integralExchange: {
          name: '积分兑换'
        },
        activity: {
          name: '活动办理'
        },
        userManage: {
          name: '用户管理'
        },
        openingAccountCenter: {
          name: '开户中心'
        },
        proxyCommission: {
          name: '代理佣金'
        },
        teamReport: {
          name: '团队报表'
        },
        safeCenter: {
          name: '安全中心'
        },
        preferential: {
          name: '优惠活动'
        },
        kefu: {
          name: '在线客服'
        },
        checkRegister: {
          name: '签到'
        },
        redbag: {
          name: '红包'
        },
        jialiDetailsKefuBtnText: {
          name: '咨询客服',
        },
        jialiDetailsKefuDialogBtnText: {
          name: '立即咨询客服'
        },
        messageCenter: {
          name: '消息中心'
        },
        walletCourse: {
          name: '如何充值'
        },
        withdrawalCourse: {
          name: '如何提款'
        },
        transferCourse: {
          name: '如何转账'
        },
        lotteryHall: {
          name: '购彩大厅',
        },
        lotteryBetHelp: {
          //官方信用购彩助手
          name: '购彩助手'
        },
        walletRechargeButton: {
          //钱包
          name: '立即充值'
        },
        vmoreGame: {
          name: '更多游戏'
        },
        vmoreGame2: {
          name: '更多游戏玩法'
        },
        herolistRtext1: {
          name: '喜中'
        },
        gameRules: {
          name: '游戏规则'
        },
        lottery: {
          name: '彩票'
        },
        lotteryGame: {
          name: '彩票游戏'
        },
        lotteryGameOrder: {
          name: '彩票注单'
        },
        bets: {
          name: '投注'
        },
        drawLottery: {
          name: '开奖'
        },
        drawLottery2: {
          name: '开奖'
        },
        drawLotteryIng: {
          name: '开奖中'
        },
        drawLotteryNumber: {
          name: '开奖号码'
        },
        drawLotteryTime: {
          name: '开奖时间'
        },
        lotteryOrder: {
          name: '注单'
        },
        lotteryTypes: {
          name: '彩种'
        },
        bonus: {
          name: '奖金'
        },
        winPrize: {
          name: '中奖'
        },
        grandprize: {
          name: '喜中大奖'
        },
        periods: {
          name: '期数'
        },
        betsTotal: {
          name: '注数'
        },
        betsUnit: {
          name: '注'
        },
        orderRollBack: {
          name: '派彩回滚'
        },
        lotteryPlayway: {
          name: '玩法'
        },
        odds: {
          name: '赔率'
        },
        balance: {
          name: '余额'
        },
        amount: {
          name: '金额'
        },
        amountUnit: {
          name: '元'
        },
        guan: {
          name: '(官)'
        },
        xin: {
          name: '(信)'
        },
        k3DA: {
          name: '大'
        },
        k3XIAO: {
          name: '小'
        },
        k3DAN: {
          name: '单'
        },
        k3SHUANG: {
          name: '双'
        },
        k3DXDSPickerTitle: {
          name: '大小单双'
        },
        backBetLotteryBasket: {
          name: '返回购彩篮'
        },
        allotedName: {
          name: '期'
        },
        lotteryTotal: {
          name: '和值'
        },
        totalAmount: {
          name: '总额'
        },
        noxListLoadErrorTips: {
          name: '加载失败点击重试'
        },
        noxListLoadMoreTips: {
          name: '点击加载更多...'
        },
        noxListLoadNoMoreTips: {
          name: '没有更多数据了'
        },
        lotteryPurchase: {
          name: '官方玩法'
        },
        lotteryCredit: {
          name: '信用玩法'
        },
        copyright: {
          name: ''
        },
        withdrawalTips: {
          name: '正在排队，等待客服进行确认'
        }
      }
      try {
        console.log('开始拷贝', state.appConfig.app_my_config.configValue, app_my_config)
        return deepAssign({}, app_my_config, state.appConfig.app_my_config.configValue)
      } catch {
        console.log('取敏感词报错了')
        return app_my_config
      }
    },
    account_type_config(state) {
      const def_account_type_config = {
        type_config: [],
        msg_config: [],
        lottery_config: []
      }

      try {
        const account_type_config = state.appConfig.account_type_config.configValue
        if (account_type_config) {
          return account_type_config
        } else {
          return def_account_type_config
        }
      } catch {
        return def_account_type_config
      }
    },
    lottery_betsetting_button_config(state) {
      const def_lottery_betsetting_button_config = [{
        handleType: 'cancel',
        label: '取消'
      },
      {
        handleType: 'shopingcar',
        label: '加入购彩篮'
      },
      {
        handleType: 'order',
        label: '立即投注'
      }
      ]
      let lottery_betsetting_button_config = []
      try {
        lottery_betsetting_button_config = state.appConfig.lottery_betsetting_button_config.configValue
      } catch {
        lottery_betsetting_button_config = def_lottery_betsetting_button_config
      }
      return lottery_betsetting_button_config
    },
    lottery_betsetting_tips_config(state) {
      const def_lottery_betsetting_tips_config = {
        title_label: '投注彩种',
        tips: '投注成功，预祝您中奖'
      }
      let lottery_betsetting_tips_config = null
      try {
        lottery_betsetting_tips_config = state.appConfig.lottery_betsetting_tips_config.configValue
      } catch {
        lottery_betsetting_tips_config = def_lottery_betsetting_tips_config
      }
      return lottery_betsetting_tips_config
    },
    // 购彩页面倒计时结束是否显示提示语
    isShowLotteryTimeendTips(state) {
      try {
        return state.appConfig.lottery_time_end_tips_config.configValue.isOpen === 1 ||
          state.appConfig.lottery_time_end_tips_config.configValue.isOpen === 0 ?
          state.appConfig.lottery_time_end_tips_config.configValue.isOpen :
          9
      } catch {
        return 9
      }
    },
    // 购彩页面倒计时结束显示的提示语
    showLotteryTimeendTips(state) {
      try {
        return state.appConfig.lottery_time_end_tips_config.configValue.tips
      } catch {
        return ''
      }
    },
    //掉线提示配置
    off_line_config(state) {
      const def_off_line_config = {
        is_error_alter: 'n',
        error_text: '您已掉线，请重新登录'
      }
      try {
        return state.appConfig.off_line_config.configValue
      } catch {
        return def_off_line_config
      }
    },
    //余额宝还是余额生金
    config_yeb(state) {
      const config_yeb = [{
        label: '余额宝',
        type: 'yeb'
      },
      {
        label: '余额生金',
        type: 'yesj'
      }
      ]
      try {
        return state.appConfig.config_yeb.configValue
      } catch {
        return config_yeb
      }
    },
    //头像配置
    portraits_config(state) {
      const def_portraits_config = {
        prefix: '',
        limit: 60,
      }
      try {
        let {
          prefix,
          limit,
        } = state.appConfig.portraits_config.configValue
        return {
          prefix: prefix || def_portraits_config.prefix,
          limit: /^[1-9]\d*$/.test(limit) ? Number(limit) : def_portraits_config.limit,
        }
      } catch {
        return def_portraits_config
      }
    }
  }
}